import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { V_URL } from "../../../BaseUrl";

export const getStoreQuotation = createAsyncThunk('/prosafe/quotation/get-quotation-list',
    async (payload) => {
        try {
            const myurl = `${V_URL}/prosafe/quotation/get-quotation-list`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {

            return error
        }
    })

const getStoreQuotationSlice = createSlice({
    name: "getStoreQuotation",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getStoreQuotation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getStoreQuotation.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getStoreQuotation.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getStoreQuotationSlice.reducer;